export class GdsgQueueLagStats {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "oldestQueueEnqueueTs",
            "baseName": "oldestQueueEnqueueTs",
            "type": "string",
            "format": ""
        },
        {
            "name": "oldestQueueAgeMs",
            "baseName": "oldestQueueAgeMs",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "activeShards",
            "baseName": "activeShards",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "observedShards",
            "baseName": "observedShards",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "mainScan",
            "baseName": "mainScan",
            "type": "GdsgQueueScanSummary",
            "format": ""
        },
        {
            "name": "revisitScan",
            "baseName": "revisitScan",
            "type": "GdsgQueueScanSummary",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GdsgQueueLagStats.attributeTypeMap;
    }
    constructor() {
    }
}
